import Feather from '@sysunite/react-feather'
import { useState, useEffect } from 'react'
import { Button, Card, Checkbox, Divider, Row, Col, Input } from 'antd'

{ Search } = Input

FilterPanel = ({ data, filterPanelOpts, searchFilter, onFilterItems, title }) ->

  [showPanel, setShowPanel] = useState(false)
  [searchString, setSearchString] = useState('')
  [checkedList, setCheckedList] = useState(filterPanelOpts)
  [indeterminate, setIndeterminate] = useState(false)
  [checkAll, setCheckAll] = useState(true)

  useEffect( ->
    searched = _.values(data).filter(searchFilter(searchString))
    if filterPanelOpts?
      onFilterItems(filterFn(searched))
    else
      onFilterItems(searched)
    undefined
  , [data, searchString, checkedList])

  onCheck = (checked, item) ->
    if checked then [checkedList..., item] else checkedList.filter((option) -> option isnt item)

  onCheckAll = (e) ->
    list = if e.target.checked then filterPanelOpts else []
    setCheckedList(list)
    setIndeterminate(false)
    setCheckAll(e.target.checked)

  onChangeItem = (list) ->
    setCheckedList(list)
    if list.length is 0
      setCheckAll(false)
    else if list.length is filterPanelOpts.length
      setCheckAll(true)
    setIndeterminate((list.length > 0) and (list.length < filterPanelOpts.length))

  filterFn = (searched) ->
    unless _.isEmpty(checkedList)
      filters = _.groupBy(checkedList, 'group')
      groups = {}
      for key, value of filters
        filteredItems = []
        for { validator } in value
          filteredItems.push(searched.filter((item) -> validator(item)))
        groups[key] = _.flatten(filteredItems)
      _.intersection(_.values(groups)...)

  panel = (
    <Card
      title="Filter #{title}"
      style={{ margin: '10px 0px' }}
    >
      <Row>
        <Col span={24}>
          <Checkbox
            style={{ margin: '2px' }}
            indeterminate={indeterminate}
            onChange={onCheckAll}
            checked={checkAll}
          >
          All
          </Checkbox>
        </Col>
        <Divider style={{ margin: '10px 0px' }}/>
        {
          filterPanelOpts?.map((op) ->
            <Col
              span={12}
              key={op.label}
            >
              <Checkbox
                style={{ margin: '2px' }}
                checked={checkedList.indexOf(op) > -1}
                onChange={({ target: { checked }}) ->
                  list = onCheck(checked, op)
                  onChangeItem(list, checked)
                }
              >
              { op.label }
              </Checkbox>
            </Col>
          )
        }
      </Row>
    </Card>
  )

  panelButton = (
    <Col span={1} style={{ textAlign: 'center' }}>
      <Button
        onClick={ -> setShowPanel(!showPanel)}
        type="secondary"
        icon={<Feather type='filter'/>}
      />
    </Col>
  )

  <div style={{ marginLeft: '8px', width: '60%' }}>
    <Row>
      <Col span={23}>
        <Search
          placeholder="Filter #{ title }"
          onChange={({ target: { value }}) -> setSearchString(value)}
        />
      </Col>
      { filterPanelOpts? && panelButton }
    </Row>
    { showPanel && panel }
  </div>

export default FilterPanel

